<template>
	<div class="cnt-pager">
		Mostrando
		<select class="qnt" v-model="dQnt">
			<option value="9999">Todos</option>
			<option value="10">{{ min_registros(10) }}</option>
			<option value="25">{{ min_registros(25) }}</option>
			<option value="50">{{ min_registros(50) }}</option>
			<option value="100">{{ min_registros(100) }}</option>
		</select>
		de {{ registros | round }} registros.

		<div class="pull-right cnt-pages">
			<nav class="pagination">
				<li
					@click="move('first')"
					v-if="qntPagers > 1"
					:class="{ disabled: value == 0 }"
				>
					<a> <i class="fas fa-angle-double-left"></i> </a>
				</li>
				<li
					@click="move('prev')"
					v-if="qntPagers > 1"
					:class="{ disabled: value == 0 }"
				>
					<a> <i class="fa fa-angle-left"></i> </a>
				</li>

				<li
					v-for="(pages, id) in qntPagers"
					:class="{ active: active(id) }"
					@click="move(pages)"
					v-if="visibles_right(id) || visibles_left(id) || active(id)"
				>
					<a> {{ pages }} </a>
				</li>

				<li
					@click="move('next')"
					v-if="qntPagers > 1"
					:class="{ disabled: value == qntPagers - 1 }"
				>
					<a> <i class="fas fa-angle-right"></i> </a>
				</li>
				<li
					@click="move('last')"
					v-if="qntPagers > 1"
					:class="{ disabled: value == qntPagers - 1 }"
				>
					<a> <i class="fas fa-angle-double-right"></i> </a>
				</li>
			</nav>
		</div>
	</div>
</template>
<script>
	import { match } from 'assert';

	export default {
		name: 'AppPaginatorGeneral',
		props: {
			qnt: {
				required: true,
			},
			value: {
				type: Number,
				required: true,
				default: 0,
			},
			registros: {
				required: true,
				default: 0,
			},
		},
		filters: {
			round(val) {
				return Math.round(val);
			},
		},
		computed: {
			qntPagers() {
				let qntPagina = Math.ceil(this.registros / this.qnt);
				if (this.value == 0 && this.registros == 0) return 1;
				else {
					if (qntPagina == 0) return 1;
					else {
						if (this.value > qntPagina) {
							this.value = 1;
							this.$emit('input', 0);
							this.$emit('updateTable');
							return 1;
						} else {
							return qntPagina;
						}
					}
				}
			},
			dQnt: {
				get() {
					return this.qnt;
				},
				set(val) {
					this.$emit('input', 0);
					this.$emit('uQnt', val);
					this.$emit('updateTable');
				},
			},
		},
		methods: {
			min_registros(min) {
				if (this.registros > min) return min;
				else return this.registros;
			},
			visibles_right(id) {
				if (id == this.value + 1 || id == this.value + 2) return true;
				if (this.value == 0 && (id == 3 || id == 4)) return true;
				if (this.value == 1 && id == 4) return true;
				return false;
			},
			visibles_left(id) {
				let ultima = this.qntPagers - 1;
				let penultima = this.qntPagers - 2;
				if (id == this.value - 1 || id == this.value - 2) return true;
				if (this.value == penultima && id == this.value - 3)
					return true;
				if (
					this.value == ultima &&
					(id == this.value - 3 || id == this.value - 4)
				)
					return true;
				return false;
			},
			move(data) {
				if (data != this.value + 1) {
					if (data == 'prev') {
						if (this.value >= 1)
							this.$emit('input', this.value - 1);
					} else if (data == 'next') {
						if (this.value < this.qntPagers - 1)
							this.$emit('input', this.value + 1);
					} else if (data == 'first') {
						this.$emit('input', 0);
					} else if (data == 'last') {
						this.$emit('input', this.qntPagers - 1);
					} else this.$emit('input', data - 1);
					this.$emit('updateTable');
				}
			},
			active(id) {
				if (id == this.value) return true;
				return false;
			},
		},
	};
</script>
<style scoped>
	.cnt-pages {
		margin: -27px -7px;
	}
	.cnt-pages a {
		cursor: pointer;
	}
	.cnt-pager {
		display: block;
		padding: 8px;
		background-color: #f9f9f9;
		border-radius: 5px;
	}
	.qnt {
		background: none;
		border: none;
	}
</style>



// WEBPACK FOOTER //
// src/app-components/table/paginator.vue